module.exports = __webpack_public_path__ + "img/58c9ea2.png";